import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { DollarTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const title = (loan) => {
  switch (loan.get('scenario')) {
    case 'Affordability':
      return `Approximately how much do you have to put down?`;
    default:
      return `How much do you expect to put down?`;
  }
};

const validateDownPayment = (num) => (num >= 0 ? '' : 'Please enter a dollar amount');

const DownPayment = ({ model, onChange, ...cardProps }) => (
  <Card title={title(model)} {...cardProps}>
    <DollarTextField
      value={model.get('downPayment')}
      onChange={onChange.bind(null, 'downPayment')}
      style={style.threeQuarters}
      floatingLabelText="Down Payment ($)"
      validate={validateDownPayment}
    />
    <br />
    <br />
    <p>Is any of the down payment coming from a gift?</p>
    <BooleanRadioButtons
      name="downPaymentGift"
      value={model.get('downPaymentGift')}
      onChange={onChange.bind(null, 'downPaymentGift')}
    />
  </Card>
);

DownPayment.id = 'DownPayment';

DownPayment.completed = ({ model }) =>
  !DollarTextField.validate(model.get('downPayment'), validateDownPayment) &&
  model.get('downPaymentGift') != null;

export default LoanCard(DownPayment);



// WEBPACK FOOTER //
// ./src/cards/down-payment.js